import { render, staticRenderFns } from "./facebook-icon.vue?vue&type=template&id=80c34422&functional=true&"
import script from "./facebook-icon.vue?vue&type=script&lang=js&"
export * from "./facebook-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports